// test2588
(2588 && 0);
